import React from 'react';


function ErrorList({status}) {
    return (
        <div>
            <div className="error-page-background ">
                <div className={"p-10 text-[15px]"}>
                    <p>
                        <span className={'bold bg-red-300 inline-block mr-10 px-2'}>EX0004</span>
                        <span>  /  \  *  ?  :  [  ]
                        해당 문자는 엑셀 시트 구성에서 금지된 문자임.
                        자산목록 엑셀에서 시트명에 자산 그룹명이 사용되므로 자산그룹명에 해당 특수문자가 들어가면 안됨.
                        </span>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default ErrorList;
